module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Nomination/nomination-san/nomination-san-form/nomination-san-form.component.css
// module id = ./src/app/hrms/Nomination/nomination-san/nomination-san-form/nomination-san-form.component.css
// module chunks = main